import { localStorageService } from '../../../infrastructure/services';
import { LocalStorage_keys, Lang_Types, FlagSources } from '../../../main/constants';

export const changeLanguageUseCase = () => {
    const localStorageLang = localStorageService.get(
        LocalStorage_keys.LANG_KEY,
        false
    );

    const spanish = Lang_Types['ES-CO'];
    const english = Lang_Types['EN-US'];

    switch (localStorageLang) {
        case spanish:
            return FlagSources['es-CO'];

        case english:
            return FlagSources['en-US'];

        default:
            localStorageService.create(LocalStorage_keys.LANG_KEY, spanish);
            return FlagSources['es-CO'];
    }
};
